export const AVAILABILITIES = [
    'BackOrder',
    'Discontinued',
    'InStock',
    'InStoreOnly',
    'LimitedAvailability',
    'OnlineOnly',
    'OutOfStock',
    'PreOrder',
    'PreSale',
    'SoldOut',
];

const getAvailabilityURL = (availability: string | null) => {
    if (!availability) {
        return undefined;
    }
    if (AVAILABILITIES.indexOf(availability) > -1) {
        return `http://schema.org/${availability}`;
    }

    return undefined;
};

export default getAvailabilityURL;


// WEBPACK FOOTER //
// ../helpers/src/schema.org/ItemAvailability.ts